import { baseApi, createEndpointBuilder } from '@/shared/api';
import type { ErrorResponse } from '@/shared/api';

import type { User, AuthResponse } from '../model/types';

const authEndpoint = createEndpointBuilder('/auth');

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    authenticateAzure: builder.mutation<AuthResponse, string, ErrorResponse>({
      query: (accessToken) => ({
        url: authEndpoint('/azure'),
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
    }),

    authenticateCiam: builder.mutation<AuthResponse, string, ErrorResponse>({
      query: (accessToken) => ({
        url: authEndpoint('/ciam'),
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
    }),

    authenticateLogin: builder.mutation<AuthResponse, { username: string; password: string }, ErrorResponse>({
      query: (body) => ({
        url: authEndpoint('/login'),
        method: 'POST',
        body
      })
    }),

    logout: builder.mutation<void, void, ErrorResponse>({
      query: () => ({
        url: authEndpoint('/logout'),
        method: 'POST'
      })
    })
  })
});

export const {
  useAuthenticateAzureMutation,
  useAuthenticateCiamMutation,
  useAuthenticateLoginMutation,
  useLogoutMutation
} = authApi;
